<table>
    <tr>
        <td><mat-icon>check</mat-icon></td>
        <td>{{data}}</td>
    </tr>
</table>